<template>
  <div>
        <v-card width="100%" class="tsandcs-container d-flex flex-column">
            <div><banner></banner></div>
            <v-card-title class="headline grey lighten-2">
                Terms and Conditions
            </v-card-title>

            <v-card-text class="my-auto text-center">

                <v-radio-group v-model="accept">
                    <v-radio
                        class="mt-0"
                        :label="'I agree to the T&C\'s for the 8WC and will be eligible for BFT global and studio prizes.'"
                        style="width: 100%"
                        value="1"
                    ></v-radio>
                    <v-radio
                        class="mt-0"
                        style="width: 100%"
                        value="2"
                    >
                        <template slot="label">
                            I agree to the T&C's for the 8WC, except I don't consent to use of my challenge images. I understand I will be ineligible for BFT global and studio prizes
                        </template>
                    </v-radio>
                </v-radio-group>

                <v-btn
                    color="primary"
                    small
                    to="/view-tsandcs"
                >
                    View the terms and conditions
                </v-btn>
            </v-card-text>



            <v-card-actions class="terms-actions d-flex flex-column pa-3">
              <v-divider></v-divider>
                <v-spacer></v-spacer>
                <div class="btn-container d-flex justify-space-between">
                    <v-btn
                        color="danger"
                        text
                        v-on:click="declineTerms()"
                    >
                        Decline
                    </v-btn>
                    <v-btn
                        color="primary"
                        :disabled="accept === 0"
                        v-on:click="acceptTerms()"
                    >
                        Continue
                    </v-btn>
                </div>

            </v-card-actions>
        </v-card>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
export default {
name: "TsAndCs",
    components: {Banner},
    data () {
        return {
            accept: 0,
            accept_no_images: false
        }
    },
    methods: {
        acceptTerms () {
            this.$store.dispatch('challenge/decideTerms', this.accept)
        },
        declineTerms () {
            this.$store.dispatch('challenge/decideTerms', 3) // decline
        }
    }
}
</script>

<style lang="scss">
.tsandcs-container {
    .btn-container {
        width: 100%;
    }

    .v-card__actions {
        justify-content: start;
    }

    .v-label {
        font-size: 14px;
    }
    .v-input__slot {
        align-items: start;
    }
    .v-radio, .v-radio:not(:last-child):not(:only-child) {
        align-items: start;
        margin-bottom: 20px;
    }
}
</style>
